import './defaultChartValues.css';
export var defaultChartSize = '_roue2g0-2-0-1';